import { render, staticRenderFns } from "./List_files.vue?vue&type=template&id=ca466646"
import script from "./List_files.vue?vue&type=script&lang=js"
export * from "./List_files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca466646')) {
      api.createRecord('ca466646', component.options)
    } else {
      api.reload('ca466646', component.options)
    }
    module.hot.accept("./List_files.vue?vue&type=template&id=ca466646", function () {
      api.rerender('ca466646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/statement_account_global/List_files.vue"
export default component.exports